import React, { Component, PropTypes } from 'react';
import { Card, Modal, Row, Col, Spin, Form, Button, Input, Icon, Select } from 'antd';
import { noImage } from 'constants/shared';
import _ from 'lodash';

import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import cn from 'classnames';
import { verifyBankAccount, verifyTax, rejectBankAccount, rejectTax, getTeacherById, editTeacher } from 'data/teacher';
import { verifyUser, rejectUser } from 'data/user';
import { formItemLayout } from 'constants/layout';
import classes from '../styles/teacher/TeacherInfo.module.scss';
import _provinces from 'constants/province';

const provinces = _.map(_provinces, (province) => ({
  value: province.name,
  label: province.name,
}));

const FormItem = Form.Item;
const Option = Select.Option;

class TeacherVerification extends Component {
  constructor(props) {
    super(props);
    this.onToggleMode = this.onToggleMode.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);

    this.handleCloseImage = this.handleCloseImage.bind(this);
    this.showImageModal = this.showImageModal.bind(this);

    this.state = {
      collapseMobile: [],
      mode: 'editor',
      showModal: false,
      selectedTab: 'info',
      isTaxPreview: true,
    };
  }

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onToggleMode() {
    const mode = this.state.mode === 'editor' ? 'preview' : 'editor';
    this.setState({
      mode,
    });
  }

  onEditorStateChange(editorState, key) {
    this.setState({
      [key]: editorState,
    });
  }

  showImageModal(url) {
    this.setState({
      showModal: true,
      imageUrl: url,
    });
  }

  handleCloseImage() {
    this.setState({
      showModal: false,
      imageUrl: '',
    });
  }

  handleUpdateProfile(id) {
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log('Received values of form: ', values);
      if (!err) {
        const newTeacher = _.merge(values, {});
        editTeacher(id, { ...newTeacher }).then(() => {
          this.props.reloadData();
          this.setState({ isTaxPreview: true });
        });

        console.log('Received values of form: ', values);
      }
    });
  }

  renderModal() {
    const imageUrl = this.state.imageUrl;

    if (!this.state.showModal) {
      return <div />;
    }
    return (
      <Modal width="960px" className={classes.imageModal} title="" visible={this.state.showModal} onCancel={this.handleCloseImage} footer={null}>
        <img src={imageUrl} />
      </Modal>
    );
  }

  renderUserVerification() {
    const { getFieldDecorator } = this.props.form;
    const { teacher } = this.props;
    const user = teacher.user;
    return (
      <div>
        <span className={'field-title underline bold'}>รูปบัตรประชาชน</span>
        <Card bordered={false} noHovering={true}>
          <div className={classes.evidence}>
            <img src={user.idCardImage || noImage} alt="" onClick={() => user.idCardImage && this.showImageModal(user.idCardImage)} />
          </div>
        </Card>
        <span className={'field-title underline bold'}>รูปถ่ายตัวเองคู่กับบัตรประชาชน</span>
        <Card bordered={false} noHovering={true} className="">
          <div className={classes.evidence}>
            <img src={user.idCardWithFaceImage || noImage} alt="" onClick={() => user.idCardWithFaceImage && this.showImageModal(user.idCardWithFaceImage)} />
          </div>
        </Card>
        <Row>
          <Col xs={24}>
            <div className={cn(classes.btnContainer, 'text-center')}>
              <Button
                type="danger"
                size=""
                onClick={() => {
                  rejectUser(teacher.user._id).then(() => this.props.reloadData());
                }}
                loading={this.props.loading}
              >
                Reject
              </Button>
              <Button
                type="success"
                size=""
                onClick={() => {
                  verifyUser(teacher.user._id).then(() => this.props.reloadData());
                }}
                loading={this.props.loading}
              >
                Approve
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderBankAccountVerification() {
    // const { getFieldDecorator } = this.props.form;
    const { teacher } = this.props;
    return (
      <div>
        <span className={'field-title underline bold'}>รูปบัญชี</span>
        <Card bordered={false} noHovering={true} className="">
          <Row gutter={16}>
            <Col xs={10}>
              <div className={classes.evidence}>
                <img src={teacher.bookbankImage || noImage} alt="" onClick={() => teacher.bookbankImage && this.showImageModal(teacher.bankImage)} />
              </div>
            </Col>
            <Col xs={14}>
              <div>
                <span className="bold">ธนาคาร:</span> {teacher.bankName}
              </div>
              <div>
                <span className="bold">เลขที่บัญชี:</span> {teacher.bankAccount}
              </div>
              <div>
                <span className="bold">ชื่อบัญชี:</span> {teacher.accountName}
              </div>
              <div>
                <span className="bold">สาขา:</span> {teacher.bankBranchName}
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={24}>
              <div className={cn(classes.btnContainer, 'text-center')}>
                <Button
                  type="danger"
                  size=""
                  loading={this.props.loading}
                  onClick={() => {
                    rejectBankAccount(teacher._id).then(() => this.props.reloadData());
                  }}
                >
                  Reject
                </Button>
                <Button
                  type="success"
                  size=""
                  onClick={() => {
                    verifyBankAccount(teacher._id).then(() => this.props.reloadData());
                  }}
                  loading={this.props.loading}
                >
                  Approve
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    );
  }

  renderTaxInput() {
    const { teacher } = this.props;
    const { taxInformation } = teacher;
    const { getFieldDecorator } = this.props.form;
    if (!taxInformation.name) {
      taxInformation.name = {};
    }

    // 'taxId',
    // 'taxFirstName',
    // 'taxLastName',
    // 'taxTitle',
    // 'taxAddress',
    // 'taxProvince',
    // 'taxPostalCode',
    return (
      <div>
        <Form>
          <FormItem {...formItemLayout} hasFeedback label="เลขบัตรประชาชน">
            {getFieldDecorator('taxId', {
              rules: [
                {
                  required: true,
                  message: 'Please input taxId',
                },
              ],
              initialValue: taxInformation.taxId,
            })(<Input placeholder="เลขบัตรประชาชน" />)}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="คำนำหน้าชื่อ">
            {getFieldDecorator('taxTitle', {
              rules: [
                {
                  required: true,
                  message: 'Please input taxTitle',
                },
              ],
              initialValue: taxInformation.title,
            })(
              <Select>
                <Option value="นาย">นาย</Option>
                <Option value="นาง">นาง</Option>
                <Option value="นางสาว">นางสาว</Option>
              </Select>,
            )}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="ชื่อ">
            {getFieldDecorator('taxFirstName', {
              rules: [
                {
                  required: true,
                  message: 'Please input firstName',
                },
              ],
              initialValue: _.get(taxInformation, 'name.first'),
            })(<Input placeholder="ชื่อ" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="นามสกุล">
            {getFieldDecorator('taxLastName', {
              rules: [
                {
                  required: true,
                  message: 'Please input lastName',
                },
              ],
              initialValue: _.get(taxInformation, 'name.last'),
            })(<Input placeholder="นามสกุล" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="ที่อยู่">
            {getFieldDecorator('taxAddress', {
              rules: [
                {
                  required: true,
                  message: 'Please input address',
                },
              ],
              initialValue: taxInformation.address,
            })(<Input placeholder="ที่อยู่" />)}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="จังหวัด">
            {getFieldDecorator('taxProvince', {
              rules: [
                {
                  required: true,
                  message: 'Please input province',
                },
              ],
              initialValue: taxInformation.province,
            })(
              <Select placeholder="จังหวัด">
                {provinces.map((province) => (
                  <Option value={province.value}>{province.value}</Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} hasFeedback label="รหัสไปรษณีย์">
            {getFieldDecorator('taxPostalCode', {
              rules: [
                {
                  required: true,
                  message: 'Please input postalCode',
                },
              ],
              initialValue: taxInformation.postalCode,
            })(<Input placeholder="รหัสไปรษณีย์" />)}
          </FormItem>
          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="primary" size="large" onClick={() => this.handleUpdateProfile(teacher._id)} loading={this.props.loading}>
              Save
            </Button>
            <Button type="danger" size="large" onClick={() => this.setState({ isPreview: true })}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  renderTaxVerification() {
    const { teacher } = this.props;
    const { taxInformation } = teacher;
    if (!taxInformation) {
      return <div />;
    }
    const name = _.get(taxInformation, 'name.first') ? `${taxInformation.title} ${_.get(taxInformation, 'name.first')} ${_.get(taxInformation, 'name.last')}` : '';
    return (
      <div>
        <span className={'field-title underline bold'}>ข้อมูลเกี่ยวกับภาษี</span>
        {this.state.isTaxPreview && (
          <div className={'pull-right pointer'} onClick={() => this.setState({ isTaxPreview: false })}>
            <Icon type="edit" /> Edit Tax Data
          </div>
        )}
        {!this.state.isTaxPreview && (
          <div className={'pull-right pointer red'} onClick={() => this.setState({ isTaxPreview: true })}>
            <Icon type="close" /> Cancel Edit
          </div>
        )}
        <Card bordered={false} noHovering={true} className="">
          {!this.state.isTaxPreview && this.renderTaxInput()}
          {this.state.isTaxPreview && (
            <div>
              <div>
                <span className="bold">เลขบัตรประชาชน:</span> {taxInformation.taxId}
              </div>
              <div>
                <span className="bold">ชื่อ:</span> {name}
              </div>
              <div>
                <span className="bold">ที่อยู่:</span> {taxInformation.address}
              </div>
              <div>
                <span className="bold">จังหวัด:</span> {taxInformation.province}
              </div>
              <div>
                <span className="bold">รหัสไปรษณีย์:</span> {taxInformation.postalCode}
              </div>
              <Row>
                <Col xs={24}>
                  <div className={cn(classes.btnContainer, 'text-center')}>
                    <Button
                      type="danger"
                      size="large"
                      loading={this.props.loading}
                      onClick={() => {
                        rejectTax(teacher._id).then(() => this.props.reloadData());
                      }}
                    >
                      Reject
                    </Button>
                    <Button
                      type="success"
                      size="large"
                      onClick={() => {
                        verifyTax(teacher._id).then(() => this.props.reloadData());
                      }}
                      loading={this.props.loading}
                    >
                      Approve
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Card>
      </div>
    );
  }

  render() {
    // console.log(this.state.files);
    const { loading, user } = this.props;

    return (
      <div>
        {
          // <div>
          //   <Button type="primary" onClick={this.onToggleMode}>
          //     {' '}
          //     {this.state.mode === 'editor' ? 'Editor' : 'Preview'}
          //   </Button>
          // </div>
        }
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <Row gutter={24} className={cn(classes.verificationContainer, 'with-margin-top')}>
            <Col xs={12} span={12} className="">
              <Card bordered={false} noHovering={true} className={classes.card}>
                {this.renderUserVerification()}
              </Card>
            </Col>
            <Col span={12} className="with-padding-left">
              <Card bordered={false} noHovering={true} className={classes.card}>
                {this.renderBankAccountVerification()}
              </Card>
              <div className={classes.cardSeperator} />
              <Card bordered={false} noHovering={true} className={classes.card}>
                {this.renderTaxVerification()}
              </Card>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}
export default connect(() => ({}), { getTeacherById, rejectTax, editTeacher })(Form.create()(TeacherVerification));
